export default __webpack_public_path__ + "static/media/general2024RealCase1-mobile-sc.c8c65611.jpg";